/**
 * LA REGLA DE LAS PREFERENCIAS DE COMIDA, EN UN SOLO SITIO (24-10).
 *
 * La usan las dos pantallas que eligen lo que más le gusta: «Tus alimentos preferidos» del
 * alta (`components/alta/PreferenciasDelAlta`) y Preferencias de Nutrición
 * (`components/nutrition/PreferencesSetup`). Cada una llevaba la suya y no pedían lo mismo:
 * Preferencias pedía 3 categorías y no contaba los alimentos sueltos para los 20 g, y el
 * alta no pedía mínimo y sí los contaba: lo que el alta daba por bueno Preferencias no lo
 * dejaba guardar.
 *
 * Manda la regla del alta, como la dejó Enrique (Francisco, 25-10): sin mínimo de
 * categorías (las grasas buenas van siempre) y, entre categorías y alimentos sueltos, 20 g
 * de proteína y 20 g de hidratos. Los 20 g los decide el motor
 * (`POST /calculator/preferencias/cuadra`); aquí solo se le prepara la pregunta.
 */

// Obligatoria: siempre marcada, no se puede desmarcar. La misma que
// `core.preferencias.SIEMPRE_PREFERIDAS`.
export const OBLIGATORY_PREFERENCES = ['grasas_buenas'];

// Pre-marcadas para clientes nuevos (todas desmarcables salvo las obligatorias).
export const DEFAULT_PREFERENCES = ['grasas_buenas', 'verduras', 'embutidos', 'lacteos', 'salsas'];

export const withObligatory = (ids) => {
    const s = new Set(ids);
    OBLIGATORY_PREFERENCES.forEach(id => s.add(id));
    return s;
};

// Las categorías preferidas de partida en el alta: las de siempre, menos las que acaba de
// quitar en la pantalla anterior, y las grasas buenas siempre dentro.
export const preferidasDePartida = (answers) => {
    const evitadas = new Set(answers.avoided_categories || []);
    const base = Array.isArray(answers.food_preferences) ? answers.food_preferences : DEFAULT_PREFERENCES;
    const fuera = base.filter(id => !evitadas.has(id));
    for (const id of OBLIGATORY_PREFERENCES) if (!fuera.includes(id)) fuera.unshift(id);
    return fuera;
};

// Lo que se le pregunta al motor: lo marcado, lo que evita y los alimentos sueltos, que
// también se le ofrecen al cuadrar y por eso cuentan para los 20 g.
export const preguntaDeLos20g = ({ marcadas, evitarCategorias, evitarPalabras, preferidos }) => ({
    marcadas: Array.from(marcadas || []),
    evitar_categorias: Array.from(evitarCategorias || []),
    evitar_palabras: Array.from(evitarPalabras || []),
    preferidos_ids: (preferidos || []).map(f => f?.id).filter(id => id != null),
});

// La respuesta del motor dice que no llega a alguno de los dos. Sin respuesta (null, o la
// llamada falló) no se frena a nadie.
export const noLlegaALos20g = (cuadra) => !!cuadra && (!cuadra.proteina || !cuadra.hidratos);
